import {z} from 'zod';
import {caseInsensitiveStringIncludes} from '@netx/core/utils/caseInsensitiveStringIncludes';

export type EditRemovesFromFilterParams<D extends object, F extends object> = {
	filters: F;
	originalData?: D;
	updatedData: D;
	schema: z.ZodObject<Record<string, z.ZodTypeAny>>;
};

export const editRemovesFromFilter = <D extends object, F extends object>({
	originalData,
	updatedData,
	filters,
	schema,
}: EditRemovesFromFilterParams<D, F>) => {
	if (!originalData) return false;

	// TODO: fix this typing - in a hurry trying some things
	return (Object.keys(filters) as unknown as Array<keyof D>).some((field) => {
		if (filters[field as unknown as keyof F] === null) return false;
		if (schema.shape[field as string] instanceof z.ZodString) {
			return !caseInsensitiveStringIncludes(
				originalData[field as keyof typeof originalData] as string,
				updatedData[field as keyof typeof updatedData] as string,
			);
		}

		return updatedData[field] !== originalData[field];
	});
};

export default editRemovesFromFilter;
